export const SET_CURRENT_SECTION = 'SET_CURRENT_SECTION';
export const SET_VIDEO_STATUS = 'SET_VIDEO_STATUS';
